export default __webpack_public_path__ + "static/media/a' coiseachd.5078baa1.mp3";